import { render, staticRenderFns } from "./event-notice.vue?vue&type=template&id=91f795c8&scoped=true"
import script from "./event-notice.vue?vue&type=script&lang=js"
export * from "./event-notice.vue?vue&type=script&lang=js"
import style0 from "./event-notice.vue?vue&type=style&index=0&id=91f795c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f795c8",
  null
  
)

export default component.exports